import PropTypes from "prop-types";

const builder = (self, method, type, initial) => {
    const name = self.constructor.name;
    method = method.bind(self);
    const typesKey = type + "Types";
    let typeSpecs = self.constructor[typesKey];
    if (typeSpecs == null) {
        throw new Error(`No ${typesKey} defined for ${name}; can't activate type checking.`);
    }
    // PropTypes doesn't allow you to declare type information where the
    // top-level properties are anonymous, which is exactly what is needed for
    // an "id lookup"-style Store. Rather than forcing the Store to deal with
    // the extra layer just to get typechecking, assume that if the store's
    // type info is a function, it's the result of an `objectOf` call for the
    // top-level state object itself. The extra named layer will be created
    // implicitly before validating. And, in fact, `objectOf` is in no way
    // special; this mechanism will allow any checker to be used for a store.
    const isChecker = typeof typeSpecs === "function";
    if (isChecker) {
        typeSpecs = {state: typeSpecs};
    }
    const check = next => {
        if (isChecker) {
            next = {state: next};
        }
        PropTypes.checkPropTypes(typeSpecs, next, type, name);
    };
    if (initial != null) {
        check(initial);
    }
    return (curr, action, contextId) => {
        const next = method(curr, action, contextId);
        if (! self.areEqual(curr, next)) {
            check(next);
        }
        return next;
    };
};

const typeCheckingStore = self => {
    if (self.reduceContext) {
        // contexted
        self.reduceContext = builder(self, self.reduceContext, "context", self.getInitialContext());
        if (self.reduceEachContext) {
            self.reduceEachContext = builder(self, self.reduceEachContext, "context");
        }
    } else if (self.reduce) {
        self.reduce = builder(self, self.reduce, "state", self.getInitialState());
    } else {
        throw new Error("No 'reduce' method found on store.");
    }
    return self;
};

export default process.env.NODE_ENV === "production"
    ? self => self
    : typeCheckingStore;



// WEBPACK FOOTER //
// ./app/data/util/typeCheckingStore.js